export const styles = {
    sectionBox: {
      backgroundColor: "#f4f6f9",
      padding: 3,
      borderRadius: 2,
      mt: 3,
    },
    sectionHeader: {
      fontWeight: 600,
      color: "#333",
      paddingBottom: 2,
      borderBottom: "2px solid #00796b",
      marginBottom: 2,
      color:'#667085'
    },
    textField: {
      backgroundColor: "#fff",
      borderRadius: 1,
      boxShadow: 1,
      "& .MuiInputBase-root": {
        borderRadius: 1,
        padding: "8px 12px",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "#00796b",
        },
        "&:hover fieldset": {
          borderColor: "#004d40",
        },
      },
    },
    menuItem: {
      fontSize: "0.9rem",
      fontWeight: 500,
    },
    textFieldSlider: {
        backgroundColor: "#fff",
        borderRadius: 1,
        mb:2,
        boxShadow: 1,
        "& .MuiInputBase-root": {
          borderRadius: 1,
          padding: "8px 12px",
        },
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: "#00796b",
          },
          "&:hover fieldset": {
            borderColor: "#004d40",
          },
        },

      },
  };
  